import useWindowPositionTop from 'hooks/useWindowPositionTop';
export default function BusinessCourse() {
    useWindowPositionTop();
  return (
    <>
      <style>{`
        /* Base styles */
        .business-course {
          white-space: pre-line;
          font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
          line-height: 1.6;
          margin: 0rem auto;
          padding: 8rem 2rem;
          box-sizing: border-box;
          background: #fff;
          color: #222;
          border-radius: 8px;
          transition: padding 0.3s ease;
        }

        .business-course h2 {
          font-size: 2.25rem;
          font-weight: 700;
          margin-bottom: 1rem;
          color: #003366;
          line-height: 1.1;
        }

        .business-course p {
          margin-bottom: 1.25rem;
          font-size: 1.125rem;
          font-weight: 400;
          color: #333;
        }

        .business-course ul {
          margin-bottom: 1.75rem;
          padding-left: 1.5rem;
          list-style-type: disc;
          color: #444;
        }

        .business-course ul li {
          margin-bottom: 0.6rem;
          font-size: 1.05rem;
          line-height: 1.4;
        }

        .business-course strong {
          font-weight: 700;
          color: #002244;
        }

        .business-course .highlight {
          font-weight: 700;
          font-size: 1.2rem;
          color: #b22222;
          margin-top: 2rem;
        }

        /* Responsive typography and spacing */
        @media (max-width: 1024px) {
          .business-course h2 {
            font-size: 1.9rem;
          }
          .business-course p,
          .business-course ul li {
            font-size: 1rem;
          }
        }

        @media (max-width: 600px) {
          .business-course h2 {
            font-size: 1.6rem;
          }
          .business-course p,
          .business-course ul li {
            font-size: 0.95rem;
          }
          .business-course ul {
            padding-left: 1.2rem;
          }
        }

        @media (max-width: 360px) {
          .business-course h2 {
            font-size: 1.4rem;
          }
          .business-course p,
          .business-course ul li {
            font-size: 0.9rem;
          }
        }
      `}</style>

      <div className="business-course">
        <h2>БИЗНЕС-КУРС</h2>
        <p>💼 ДОСТИГНИТЕ НОВОГО УРОВНЯ В БИЗНЕСЕ С ПРОФЕССИОНАЛЬНЫМ АНГЛИЙСКИМ!</p>
        <p>
          Бизнес-курс английского языка — ваш ключ к международным возможностям и карьерному росту!
        </p>
        <p><strong>Почему именно наш курс?</strong></p>
        <p>✨ Уникальные преимущества:</p>
        <ul>
          <li>Специализированная программа для бизнес-среды</li>
          <li>Практический подход к деловому общению</li>
          <li>Работа с реальными бизнес-кейсами</li>
          <li>Индивидуальный подход к каждому студенту</li>
        </ul>
        <p><strong>🎯 Что вы получите:</strong></p>
        <ul>
          <li>Уверенное ведение деловых переговоров</li>
          <li>Профессиональный бизнес-словарный запас</li>
          <li>Навыки деловой переписки</li>
          <li>Умение презентовать на английском</li>
          <li>Знание бизнес-этикетта</li>
        </ul>
        <p><strong>🏆 Ключевые модули курса:</strong></p>
        <ul>
          <li>Деловая коммуникация — переговоры, встречи, презентации</li>
          <li>Письменный английский — письма, отчеты, контракты</li>
          <li>Бизнес-лексика — терминология по отраслям</li>
          <li>Межкультурная коммуникация — особенности ведения бизнеса в разных странах</li>
        </ul>
        <p><strong>💡 Особенности обучения:</strong></p>
        <ul>
          <li>Практические занятия о мной, а так же с носителями языка</li>
          <li>Ситуационные тренинги в бизнес-среде</li>
          <li>Интерактивные упражнения для развития навыков</li>
          <li>Персональная обратная связь от меня</li>
        </ul>
        <p><strong>💫 Для кого этот курс:</strong></p>
        <ul>
          <li>Руководителей и топ-менеджеров</li>
          <li>Бизнес-профессионалов</li>
          <li>Специалистов международных компаний</li>
          <li>Предпринимателей</li>
          <li>Всех, кто стремится к карьерному росту</li>
        </ul>
        <p><strong>🎁 Дополнительные бонусы:</strong></p>
        <ul>
          <li>Доступ к бизнес-библиотеке</li>
          <li>Участие в бизнес-симуляциях</li>
          <li>Нетворкинг с единомышленниками</li>
          <li>Консультации по деловому этикету</li>
        </ul>
        <p><strong>🎯 Результаты курса:</strong></p>
        <ul>
          <li>Уверенность в деловых коммуникациях</li>
          <li>Расширение профессиональных возможностей</li>
          <li>Повышение конкурентоспособности</li>
          <li>Новые карьерные перспективы</li>
        </ul>
        <p><strong>🔥 Специальное предложение:</strong></p>
        <p>При записи сейчас:</p>
        <ul>
          <li>Скидка 20% на полный курс</li>
          <li>Бесплатный пробный урок</li>
          <li>Персональная диагностика уровня</li>
          <li>Бизнес-план развития языка</li>
        </ul>
        <p>
          Не упустите шанс вывести свою карьеру на международный уровень!
        </p>
        <p className="highlight">
          📞 ЗАПИШИТЕСЬ НА ПРОБНОЕ ЗАНЯТИЕ ПРЯМО СЕЙЧАС!<br />
          Количество мест в группах ограничено!<br />
          Ваш успех в международном бизнесе начинается здесь!
        </p>
        <p>#бизнесанглийский #английскийдлябизнеса #бизнескурсы #деловоеобщение #карьера</p>
      </div>
    </>
  );
}

